// Iowa State University's undergraduate majors (#2748). Read on 2026-10-01
// from the official 2026-2027 Catalog's "Undergraduate Majors" list
// (catalog.iastate.edu/collegescurricula/), which names every major with
// its degree and links it to the college whose catalog section holds it;
// each major is grouped by that link. Kept: every primary bachelor's major.
// Left out: secondary majors (earned only with a primary major),
// certificates, minors and pre-professional study. Majors two colleges both
// offer (Biochemistry, Biology, Nursing, Food Science and others) appear
// under each. Classical Studies and U.S. Latino/a Studies are listed by the
// catalog as Interdisciplinary Studies areas; French, German and Spanish
// as World Languages and Cultures areas. Athletic Training is the catalog's
// 3+2 B.S./M.A.TR. program (its catalog page). Names and degree
// abbreviations are the catalog's own. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "iowa-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Iowa State's official 2026-2027 Catalog, grouped by the college that offers it, with the degree it leads to. Secondary majors, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture and Life Sciences",
            "source": {
                "label": "Iowa State University 2026-2027 Catalog, Undergraduate Majors",
                "url": "https://catalog.iastate.edu/collegescurricula/"
            },
            "majors": [
                {
                    "name": "Agricultural and Life Sciences Education",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural and Rural Policy Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Business",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Systems Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Agronomy",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Science",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Enterprise and Innovation",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Culinary Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Dairy Science",
                    "degree": "B.S."
                },
                {
                    "name": "Diet and Exercise",
                    "degree": "B.S./M.S."
                },
                {
                    "name": "Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Digital and Precision Agriculture",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Forestry",
                    "degree": "B.S."
                },
                {
                    "name": "Genetics",
                    "degree": "B.S."
                },
                {
                    "name": "Global Resource Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Horticulture",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nutritional Science",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife and Fisheries Conservation and Ecology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Ivy College of Business",
            "source": {
                "label": "Iowa State University 2026-2027 Catalog, Undergraduate Majors",
                "url": "https://catalog.iastate.edu/collegescurricula/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Healthcare Management",
                    "degree": "B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Design",
            "source": {
                "label": "Iowa State University 2026-2027 Catalog, Undergraduate Majors",
                "url": "https://catalog.iastate.edu/collegescurricula/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Game Design",
                    "degree": "B.S."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Illustration",
                    "degree": "B.F.A."
                },
                {
                    "name": "Industrial Design",
                    "degree": "B.I.D."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "B.L.A."
                },
                {
                    "name": "Urban and Regional Planning",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Iowa State University 2026-2027 Catalog, Undergraduate Majors",
                "url": "https://catalog.iastate.edu/collegescurricula/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Cyber Security Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Software Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Health and Human Sciences",
            "source": {
                "label": "Iowa State University 2026-2027 Catalog, Undergraduate Majors",
                "url": "https://catalog.iastate.edu/collegescurricula/"
            },
            "majors": [
                {
                    "name": "Athletic Training",
                    "degree": "B.S./M.A.TR.",
                    "note": "A 3+2 program: three years of pre-athletic training, then the two-year master's; the B.S. comes only on finishing both."
                },
                {
                    "name": "Culinary Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Diet and Exercise",
                    "degree": "B.S./M.S."
                },
                {
                    "name": "Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childcare Education and Programming",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Education Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Event Management",
                    "degree": "B.S."
                },
                {
                    "name": "Family and Consumer Sciences Education and Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Fashion Design and Merchandising",
                    "degree": "B.S."
                },
                {
                    "name": "Financial Counseling and Planning",
                    "degree": "B.S."
                },
                {
                    "name": "Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality Management",
                    "degree": "B.S."
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology and Health",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing, Accelerated",
                    "degree": "B.S.N.",
                    "note": "For students who already hold a bachelor's degree."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nutritional Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "Iowa State University 2026-2027 Catalog, Undergraduate Majors",
                "url": "https://catalog.iastate.edu/collegescurricula/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Bioinformatics and Computational Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Climate Science",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Digital Storytelling",
                    "degree": "B.A."
                },
                {
                    "name": "Earth Science Education and Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Earth Science",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Genetics",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Integrated Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism and Mass Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.L.S.",
                    "note": "A general studies degree."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Meteorology",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A., B.Mus."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Professional Studies",
                    "degree": "B.L.S.",
                    "note": "A general studies degree."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Scientific Illustration and Visualization",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Software Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Sports Media and Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Technical Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "B.A.",
                    "note": "French, German or Spanish."
                }
            ]
        },
        {
            "name": "Interdisciplinary Programs",
            "source": {
                "label": "Iowa State University 2026-2027 Catalog, Undergraduate Majors",
                "url": "https://catalog.iastate.edu/collegescurricula/"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A., B.S.",
                    "note": "Includes Classical Studies and U.S. Latino/a Studies."
                }
            ]
        }
    ]
};

export default majors;
